import IconBase from "../IconBase";

const FacebookIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M18.0011 2.00012H15.0011C13.675 2.00012 12.4033 2.52691 11.4656 3.46459C10.5279 4.40227 10.0011 5.67404 10.0011 7.00012V10.0001H7.00113V14.0001H10.0011V22.0001H14.0011V14.0001H17.0011L18.0011 10.0001H14.0011V7.00012C14.0011 6.73491 14.1065 6.48055 14.294 6.29302C14.4816 6.10548 14.7359 6.00012 15.0011 6.00012H18.0011V2.00012Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default FacebookIcon;
